import { render, staticRenderFns } from "./pcaj.vue?vue&type=template&id=ec918eba&scoped=true&"
import script from "./pcaj.vue?vue&type=script&lang=js&"
export * from "./pcaj.vue?vue&type=script&lang=js&"
import style0 from "./pcaj.vue?vue&type=style&index=0&id=ec918eba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec918eba",
  null
  
)

export default component.exports